import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function TermsComponent() {
  return (
    <Container
      id="privacy"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 }
      }}>
      <Typography
        component="h1"
        variant="h4"
        color="text.primary"
        sx={{
          width: { sm: '100%', md: '80%' },
          textAlign: 'center',
          mb: 4
        }}>
        ⚖️ Terms of Service
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2
        }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h6" component="h2" gutterBottom>
            Legal Disclaimer
          </Typography>
          <Typography variant="body1" paragraph>
            Last Updated: July 24, 2025
          </Typography>
          <Typography variant="body1" paragraph>
            SCA CASES LTD is a UK-registered company (Company No. 16409485) that provides
            educational resources for medical trainees preparing for the MRCGP Simulated
            Consultation Assessment (SCA). All materials are created by qualified General
            Practitioners who have recently completed their CCT and have first-hand experience with
            the SCA exam.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Educational Use Only
          </Typography>
          <Typography variant="body1" paragraph>
            This website is intended solely for educational and revision purposes. The content is
            designed to simulate real-life consultation scenarios in a format similar to the SCA
            exam. It is not a source of clinical advice and must not be used to guide patient care
            or substitute medical training or supervision.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            No Affiliation with the RCGP
          </Typography>
          <Typography variant="body1" paragraph>
            SCA CASES LTD is not affiliated with, endorsed by, or connected to the Royal College of
            General Practitioners (RCGP) or any other examination body or institution. The cases
            provided are original creations inspired by common general practice scenarios and
            formatted in a way that reflects the SCA structure. They do not represent official SCA
            material or past exam content.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            All content on this platform — including but not limited to written case material,
            structure, design, and branding — is the intellectual property of SCA CASES LTD and is
            protected by copyright.
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>You may use the content solely for personal revision or small-group training.</li>
            <li>
              You may not copy, reproduce, share, distribute, or resell any material without express
              written permission from the company.
            </li>
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            While we strive to ensure that the content is accurate, up to date, and reflective of
            current clinical and educational standards, we do not guarantee success in the MRCGP
            exam or accept responsibility for any actions taken based on use of the platform. Users
            are responsible for their own clinical decisions and exam preparation.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            Use of this website constitutes acceptance of these terms. If you have questions
            regarding usage or permissions, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email: <Link href="mailto:scacases@gmail.com">scacases@gmail.com</Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
